export enum SplitScreenTab {
    SCENE = 'scene',
    IMAGE_DB = 'imagedb',
    NETWORK_ARCHITECTURE = 'skillarchitecture',
    EVALUATION = 'evaluation',
    COST_FUNCTION = 'costfunction',
    ALGORITHM = 'algorithm',
}
